import { API_URLs } from "../../utilities/API_URLs";
import { Http } from "../../utilities/axios/http";

export class ContainerService {
  static getContainerById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.merchandise.container}/${id}`);
    } catch (error) {
      return error;
    }
  }
}

export class BagService {
  static getBagById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.merchandise.bag}/${id}`);
    } catch (error) {
      return error;
    }
  }
}

export class VehicleService {
  static getVehicleById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.merchandise.vehicle}/${id}`);
    } catch (error) {
      return error;
    }
  }
}

export class CraftService {
  static getCraftById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.merchandise.craft}/${id}`);
    } catch (error) {
      return error;
    }
  }
}

export class OtherService {
  static getOtherById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.merchandise.other}/${id}`);
    } catch (error) {
      return error;
    }
  }
}